import styled, { css } from 'styled-components';
import { listWidth, smallScreenListWidth } from '../styled';
import { Box } from '@bechtel/gds';

export const CrewListContainerStyled = styled.div`
  background-color: ${({ theme }) => theme.colors.white};
  display: flex;
  flex-direction: column;
  height: 100vh;
  left: 0;
  position: absolute;
  top: 0;
  width: ${listWidth};
  @media only screen and (max-width: ${({ theme }) => theme.breakpoints.widescreen}) {
    width: ${smallScreenListWidth};
  }
  box-shadow: 0 3px 5px -1px rgba(0, 0, 0, 0.2), 0 1px 18px 0 rgba(0, 0, 0, 0.12), 0 6px 10px 0 rgba(0, 0, 0, 0.14);
  color: ${({ theme }) => theme.colors.grey[1000]};
  &::before {
    box-shadow: 14px 0 12px -8px rgba(0, 0, 0, 0.1);
    content: '';
    height: 100%;
    pointer-events: none;
    position: absolute;
    right: 0;
    width: 32px;
  }
`;

export const DateHeaderStyled = styled(Box)`
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.2), 0 2px 1px -1px rgba(0, 0, 0, 0.12), 0 1px 1px 0 rgba(0, 0, 0, 0.14);
  background-color: ${({ theme }) => theme.colors.white};
`;

export const CrewHeadingStyled = styled(Box).attrs({
  pb: { sm: '500' },
  pt: { sm: '700' },
  px: { sm: '500' },
})`
  ${({ theme }) => css`
    background-color: ${theme.colors.grey[200]};
    border-bottom: solid 1px ${theme.colors.grey[300]};
  `}
`;

export const CrewListStyled = styled(Box).attrs({
  flexDirection: { sm: 'column' },
})`
  height: 100%;
  overflow-y: auto;
`;
